import { StringParam, withDefault } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';
import { AccountType } from '../types';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'fullNumber',
    label: 'No.',
  },
  {
    name: 'search',
    label: 'Name',
  },
  {
    name: 'accountType',
    label: 'Type',
  },
  {
    name: 'closed',
    label: 'Status',
  },
  {
    name: 'debitIn',
    label: 'Debit IN',
  },
  {
    name: 'creditIn',
    label: 'Credit IN',
  },
  {
    name: 'debitTo',
    label: 'Debit TO',
  },
  {
    name: 'creditTo',
    label: 'Credit TO',
  },
  {
    name: 'debitOut',
    label: 'Debit OUT',
  },
  {
    name: 'creditOut',
    label: 'Credit OUT',
  },
];

export const defaultSorter = {
  sortProp: columns[1].name,
  sortDir: SortDir.ASC,
};

export const schema = {
  transferDate: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['transferDateFrom', 'transferDateTo'],
  },
  transferDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  transferDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  excludeRevaluation: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  roundDecimals: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  daysOffset: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  search: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  closed: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  accountType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  categoryId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  groupId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  primaryId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'accountType',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'accountType',
        title: 'Debit',
        value: AccountType.DEBIT.toLocaleUpperCase(),
      },
      {
        name: 'accountType',
        title: 'Credit',
        value: AccountType.CREDIT.toLocaleUpperCase(),
      },
    ],
  },
  {
    name: 'search',
    type: FilterType.TEXT,
    placeholder: 'Search by name...',
  },
  {
    name: 'closed',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'closed',
        title: 'Open',
        value: 'false',
      },
      {
        name: 'closed',
        title: 'Closed',
        value: 'true',
      },
    ],
  },
  {
    name: 'categoryId',
    type: FilterType.AUTOCOMPLETE,
  },
  {
    name: 'groupId',
    type: FilterType.AUTOCOMPLETE,
  },
  {
    name: 'primaryId',
    type: FilterType.AUTOCOMPLETE,
  },
];

export const columnsLabels = {
  search: 'Account',
  accountType: 'Type',
  closed: 'Status',
  categoryId: 'Category',
  groupId: 'Group',
  primaryId: 'Primary Account',
};
